"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const OverlayService_1 = require("src/OverlayService");
const useBodyScrollLock = (popup) => {
    React.useEffect(() => {
        if (popup) {
            OverlayService_1.overlayService.enableBodyScrollLock();
        }
        else {
            OverlayService_1.overlayService.disableBodyScrollLock();
        }
    }, [popup]);
};
exports.default = useBodyScrollLock;
